/*
  スマホのドロワーの子メニュー ▼で開く（2026/9/18）
  読み込み: sections/header.liquid の設定 sp_nav_children が accordion / accordion_open の時（とテーマエディタの中）だけ
  accordion_open は初期状態だけ開く。開閉UIは accordion と同じで、ドロワーを閉じたら初期状態へ戻る
  マークアップ: snippets/sp-nav-drawer-item.liquid（[data-sp-nav-toggle] と aria-controls で結ぶ .sp-nav-panel）

  🛑 開閉のボタンに <button> を使わない理由: assets/global.js の MenuDrawer.bindEvents は起動時に
     ドロワー内の全 <button> へ onCloseButtonClick を付け、押すと closest('details')＝ドロワー本体を閉じる。
     同じ要素の処理は登録順に動くので、後から stopImmediatePropagation しても間に合わない。
  🛑 document の「捕捉（capture）」段階で受けて stopPropagation する理由:
     もとは assets/script.js.liquid の $(".menu-drawer-container").click（泡立ち段階）が、ドロワー内のクリックごとに
     開く演出のクラス（headerFadeUp）と見える／見えない（.active）を付け外ししていて、▼を押すと次に開いた時に反転した。
     2026/10/19 にその回数トグルは撤去し <details> の open／.menu-opening に連動させたが、ドロワー内のクリックが
     <details> に泡立つ作りは変わらないので、捕捉段階で止める形はそのまま残す（同じ型の処理が増えても ▼ は守られる）。
     捕捉段階の document は必ずそれより先に動く。要素ごとに付けないので、テーマエディタがヘッダーを
     描き直しても（shopify:section:load）付け直しが要らない。
  🛑 ドロワーを閉じたら ▼を各パネルの初期状態に戻す: global.js の closeMenuDrawer は <details> しか戻さない。
     <details> の toggle イベントは泡立たないが、捕捉段階なら document で受けられる。
  既存の旧アコーディオン（script.js.liquid の .nav__item__title__icon → .products__nav を slideToggle）は
  ▼の直後の要素を開く作りで aria も持たないため、クラス名を分けて使っていない（見た目の ▼ だけ同じ画像）。
*/
(function () {
  var DRAWER_ID = 'Details-menu-drawer-container';

  function toggleOf(target) {
    return target && target.closest ? target.closest('.menu-drawer [data-sp-nav-toggle]') : null;
  }

  function setOpen(el, open) {
    var panel = document.getElementById(el.getAttribute('aria-controls'));
    if (!panel) return;
    el.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  document.addEventListener('click', function (event) {
    var el = toggleOf(event.target);
    if (!el) return;
    event.preventDefault();
    event.stopPropagation();
    setOpen(el, el.getAttribute('aria-expanded') !== 'true');
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var el = toggleOf(event.target);
    if (!el) return;
    event.preventDefault();
    event.stopPropagation();
    setOpen(el, el.getAttribute('aria-expanded') !== 'true');
  }, true);

  document.addEventListener('toggle', function (event) {
    var drawer = event.target;
    if (!drawer || drawer.id !== DRAWER_ID || drawer.open) return;
    drawer.querySelectorAll('[data-sp-nav-toggle]').forEach(function (el) {
      setOpen(el, el.getAttribute('data-sp-nav-initial') === 'open');
    });
  }, true);
})();
